import { Component, computed, EventEmitter, inject, Input, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ITieDetails } from '../../../models/ITieDetails';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../../services/api.service';


@Component({
  selector: 'app-tie-bid',
  imports: [FontAwesomeModule,
    ButtonModule,
    DialogModule,
    CommonModule],
  templateUrl: './tie-bid.component.html',
  styleUrl: './tie-bid.component.scss'
})
export class TieBidComponent {
  faCheckCircle = faCheckCircle;

  @Input() visible = false;
  @Input() tieExplanation!: ITieDetails | null;
  @Output() close = new EventEmitter<void>();

  private readonly apiService = inject(ApiService);
  protected currency = computed(() => this.apiService.auctionConfigSignal()?.currency ?? '')

  onClose() {
    this.close.emit();
  }

}
